import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import { useCurrentUser } from '../../../auth/useCurrentUser';
import { colors } from '../../../theme/tokens';

import UsersAdminPageLegacy from './UsersAdminPageLegacy';
import UsersAdminPageV2 from './UsersAdminPageV2';

/**
 * Flag switch (RBAC_V2, design §9). Flag off ⇒ `UsersAdminPageLegacy`
 * (today's page, byte-identical). Flag on ⇒ `UsersAdminPageV2` (3-tab
 * Users | Roles | Tenant Groups). The spinner while `/api/me` resolves
 * mirrors `AdminLayout`'s loading branch, so this page's shell doesn't
 * flash the wrong variant on a direct `/admin/users` load.
 */
const UsersAdminPage: React.FC = () => {
  const { rbacV2Enabled, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress sx={{ color: colors.brand }} />
      </Box>
    );
  }

  return rbacV2Enabled ? <UsersAdminPageV2 /> : <UsersAdminPageLegacy />;
};

export default UsersAdminPage;
